import React from "react";
import {Row, Col, List, DatePicker} from "antd";
import {Stats} from "../_defaultComponents/Stats/Stats";

import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";

import {timeRangeOptionsStatistics} from "../../constants/constants";
import {RangePickerContainer, Title, SelectField} from "./statisticsStyles";
import {EmptyMessage} from "../_defaultComponents/EmptyMessage/EmptyMessage";

export const Statistic = ({
    title,
    dateType,
    dataSource,
    minute,
    loading,
    progressLoading,
    type,
    selectFieldOnChange,
    setPercentage,
    rangePickerOnChange
}) => {
    const {RangePicker} = DatePicker;
    const {t} = useTranslation(["timeRangeOptionsStatistics"]);

    return useObserver(() => (
        <div data-testid="statisticCard">
            <Title data-testid="title">{title}</Title>

            <Row>
                {rangePickerOnChange ? (
                    <Col xs={20} sm={16} md={12} lg={8} xl={4} span={4}>
                        <SelectField
                            data-testid="timeRangeSelect"
                            value={dateType}
                            onChange={value => {
                                selectFieldOnChange(value);
                            }}
                        >
                            {timeRangeOptionsStatistics.map((obj, i) => (
                                <SelectField.Option
                                    key={i}
                                    data-testid="timeRangeSelect_option"
                                    value={obj.value}
                                >
                                    {t(obj.translation_key, {
                                        ns: "timeRangeOptionsStatistics"
                                    })}
                                </SelectField.Option>
                            ))}
                        </SelectField>
                    </Col>
                ) : null}
                <Col>
                    {dateType === "choose" && (
                        <RangePickerContainer>
                            <RangePicker
                                data-testid="timeRangePicker"
                                renderExtraFooter={() =>
                                    t("timeRangePickerPlaceholder", {ns: "common"})
                                }
                                onChange={(values, formatString, info) => {
                                    rangePickerOnChange(formatString);
                                }}
                            />
                        </RangePickerContainer>
                    )}
                </Col>
            </Row>
            <List
                grid={{gutter: 16, column: 5}}
                dataSource={Object.entries(dataSource)}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                renderItem={item => (
                    <List.Item>
                        <Stats
                            item={item}
                            minute={minute}
                            setPercentage={setPercentage}
                            loading={loading}
                            progressLoading={progressLoading}
                            type={type}
                        />
                    </List.Item>
                )}
            />
        </div>
    ));
};
